import './editable-select.scss'

import { Button, Divider, Input } from 'antd'
import { Select, SelectProps } from 'formik-antd'
import { useState } from 'react'
import { Row } from 'react-display-flex'

import { filterProps } from '../forms/utils'

interface EditableSelectProps {
  addItemLabel?: string
  addItemPlaceholder?: string
  onOptionAdded: (value: string) => void
}

export const EditableSelect = ({
  options,
  onOptionAdded,
  name,
  addItemLabel,
  addItemPlaceholder,
  ...selectOptions
}: SelectProps<any> & EditableSelectProps) => {
  const [currentOptions, setCurrentOptions] = useState(options)
  const [newOption, setNewOption] = useState('')

  return (
    <Select
      {...selectOptions}
      {...filterProps}
      options={currentOptions}
      name={name}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider />
          <Row className="editable-form-item">
            <Input
              placeholder={addItemPlaceholder || 'Please enter item'}
              name="newSegmentCode"
              value={newOption}
              onChange={(event) => setNewOption(event.target.value.replace(/\s/g, '_').toLocaleUpperCase())}
            />
            <Button
              onClick={() => {
                setCurrentOptions([...currentOptions, { label: newOption, value: newOption }])
                setNewOption('')
                onOptionAdded(newOption)
              }}
              style={{ whiteSpace: 'nowrap' }}
            >
              {addItemLabel || 'Add item'}
            </Button>
          </Row>
        </>
      )}
    />
  )
}
